import React, { Component } from "react";
import Form from "../Form/Form";
import { connect } from "react-redux";
import Captcha from "assets/scripts/components/common/form/Captcha/Captcha";
import createRef from "assets/scripts/utils/createRef";
class CaptchaForm extends Component {
    constructor() {
        super(...arguments);
        this._captcha = createRef();
        this.state = {
            captcha: null
        };
        this._handleCaptchaChange = (captcha) => {
            if (this.state.captcha !== captcha) {
                this.setState({ captcha });
            }
        };
        this._handleSubmit = () => {
            if (this._captcha.value != null) {
                this._captcha.value.reset();
            }
            this.props.onSubmit(this.state.captcha);
        };
    }
    render() {
        const { props, state } = this;
        const { children, isRequiredCaptcha, force, submitDisabled, onSubmit, ...otherProps } = props;
        const captchaRequired = force || isRequiredCaptcha;
        const captchaValid = !captchaRequired || state.captcha != null;
        const captcha = (<Captcha ref={this._captcha} required={captchaRequired} onChange={this._handleCaptchaChange}/>);
        return (<Form {...otherProps} submitDisabled={!captchaValid || submitDisabled} onSubmit={this._handleSubmit}>
				{children(captcha)}
			</Form>);
    }
}
export default connect((state) => ({
    isRequiredCaptcha: state.auth.isRequiredCaptcha
}))(CaptchaForm);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/CaptchaForm/CaptchaForm.tsx